import type { Action, Resource } from "@/types/permissions";
import { UserRole } from "@/types/user";
import { ROLE_PERMISSIONS } from "./permissions-matrix";

// Helper function to check permissions
export const hasPermission = (
  role: UserRole,
  resource: Resource,
  action: Action
): boolean => {
  const permissions = ROLE_PERMISSIONS[role];
  const resourcePerm = permissions.find((perm) => perm.resource === resource);
  return resourcePerm ? resourcePerm.actions.includes(action) : false;
};

// Context-aware check — pass in what you know about the current entity
export interface PermissionContext {
  userId: string;
  projectPmId?: string;
  projectSeId?: string;
  entityOwnerId?: string; // e.g., who submitted the invoice, who created the task
}

export function hasContextualPermission(
  role: UserRole,
  resource: Resource,
  action: Action,
  ctx: PermissionContext
): boolean {
  // Superadmin always passes — no further checks needed
  if (role === UserRole.SUPERADMIN) return true;

  // Base permission must exist first
  if (!hasPermission(role, resource, action)) return false;

  // PM can only act on projects they're assigned to
  if (role === UserRole.PM) {
    if (ctx.projectPmId && ctx.projectPmId !== ctx.userId) return false;
  }

  // SE can only act on projects they're assigned to
  if (role === UserRole.SE) {
    if (ctx.projectSeId && ctx.projectSeId !== ctx.userId) return false;
  }

  return true;
}